$(document).ready(function () {
    $('.container,.container-fluid,.container-wide').each(function() {
        let $mushroomProducts = $(this).find('.mushroom-product a');
        $mushroomProducts.on('click', function(e) {
            e.stopPropagation();
        });
        $mushroomProducts.magnificPopup({
            type: 'image',
            gallery: {
                enabled: true
            },
            mainClass: 'mushroom-product-popup'
        })
    });
});
